(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kamio-game-hub"] && !Shopify.designMode) return;
  try {
    
/* ----- Boot sequence ----- */
const lines=[
  "> INITIALIZING KAMIO_OS...",
  "> LOADING ANIME MODULE........ <b>OK</b>",
  "> LOADING GAME ENGINE......... <b>OK</b>",
  "> LOADING STORE & MERCH....... <b>OK</b>",
  "> MOUNTING WEBTOON FEED....... <b>OK</b>",
  "> CREATIVE SYSTEMS ONLINE."
];
const log=document.getElementById('bootlog');
const bar=document.querySelector('.boot-bar i');
const boot=document.getElementById('boot');
let li=0;
const prefersReduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
function typeLine(){
  if(li<lines.length){
    log.innerHTML+=lines[li]+"<br>";
    bar.style.width=Math.round(((li+1)/lines.length)*100)+"%";
    li++;
    setTimeout(typeLine, prefersReduce?60:340);
  } else {
    setTimeout(()=>{boot.classList.add('done');startReveals();}, prefersReduce?100:520);
  }
}
window.addEventListener('load',()=>{ prefersReduce?(boot.classList.add('done'),startReveals()):typeLine(); });

/* ----- Reveal on scroll ----- */
function startReveals(){
  const io=new IntersectionObserver((es)=>{
    es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
  },{threshold:.15});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
}

/* ----- Custom cursor (fine-pointer devices only) ----- */
const ring=document.querySelector('.cursor'), dot=document.querySelector('.cur-dot');
const finePointer = window.matchMedia('(pointer:fine)').matches;
if(ring && dot && finePointer && !prefersReduce){
  const ringSvg=ring.querySelector('svg'), ringCircle=ring.querySelector('circle');
  let rx=0,ry=0,dx=0,dy=0,moved=false,rafId=null;
  function follow(){rx+=(dx-rx)*.18;ry+=(dy-ry)*.18;ring.style.left=rx+'px';ring.style.top=ry+'px';rafId=requestAnimationFrame(follow);}
  window.addEventListener('mousemove',e=>{dx=e.clientX;dy=e.clientY;dot.style.left=dx+'px';dot.style.top=dy+'px';if(!moved){moved=true;follow();}},{passive:true});
  document.querySelectorAll('a,button,summary').forEach(el=>{
    el.addEventListener('mouseenter',()=>{if(ringSvg)ringSvg.style.transform='scale(1.5)';if(ringCircle)ringCircle.setAttribute('stroke','#ffffff');});
    el.addEventListener('mouseleave',()=>{if(ringSvg)ringSvg.style.transform='scale(1)';if(ringCircle)ringCircle.setAttribute('stroke','#ffc233');});
  });
} else if(ring && dot){ ring.style.display='none'; dot.style.display='none'; }

/* ----- Mobile nav ----- */
const toggle=document.querySelector('.nav-toggle'), topnav=document.querySelector('nav.top');
toggle.addEventListener('click',()=>{const o=topnav.classList.toggle('open');toggle.setAttribute('aria-expanded',o);});
topnav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{topnav.classList.remove('open');toggle.setAttribute('aria-expanded',false);}));

/* ----- Parallax orbs (fine-pointer, motion allowed) ----- */
(function(){
  const orb1=document.querySelector('.orb1'), orb2=document.querySelector('.orb2');
  if(!orb1 || !orb2 || !finePointer || prefersReduce) return;
  let px=0,py=0,ticking=false;
  function apply(){orb1.style.transform=`translate(${px*40}px,${py*40}px)`;orb2.style.transform=`translate(${-px*40}px,${-py*40}px)`;ticking=false;}
  window.addEventListener('mousemove',e=>{
    px=(e.clientX/window.innerWidth-.5);py=(e.clientY/window.innerHeight-.5);
    if(!ticking){ticking=true;requestAnimationFrame(apply);}
  },{passive:true});
})();

/* ===================== TIGER RUN ===================== */
(function(){
  const cv=document.getElementById('tigerGame');
  if(!cv) return;
  const ctx=cv.getContext('2d');
  const W=cv.width, H=cv.height, GROUND=H-46;
  const overlay=document.getElementById('tigerOverlay');
  const startBtn=document.getElementById('tigerStart');
  const goTitle=document.getElementById('goTitle');
  const goSub=document.getElementById('goSub');
  const scoreEl=document.getElementById('tigerScore');
  const bestEl=document.getElementById('tigerBest');
  const livesEl=document.getElementById('tigerLives');
  const reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // player sprite sheet: 3 cols x 4 rows of 64x64; row 2 = facing right (run cycle)
  // embedded inline as a data URI so it always loads (no separate asset upload needed)
  const PLAYER={img:new Image(), ready:false, fw:64, fh:64, runRow:2, cols:3};
  PLAYER.img.onload=()=>{ PLAYER.ready=true; };
  PLAYER.img.src="data:image/webp;base64,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";

  let best=0; // in-memory only (no storage in artifacts)
  let state='idle'; // idle | running | dead
  let tiger, obstacles, enemies, particles, speed, score, spawnT, frame, gravity, lives, bgT;

  // background shifts from day through dusk into night, then eases back via dawn
  const BGS=[
    {name:'day',   top:'#4a78c8', bot:'#a9c8e8', hill:'#3a4f78', star:0},
    {name:'dusk',  top:'#5a3a7a', bot:'#d8754a', hill:'#3a1f3e', star:0},
    {name:'night', top:'#080b1c', bot:'#141226', hill:'#0c0a1e', star:1},
    {name:'dawn',  top:'#3a3a66', bot:'#c89a6a', hill:'#2e2240', star:0}
  ];
  const BG_PERIOD=120; // points per phase

  function reset(){
    tiger={x:90,y:GROUND,vy:0,w:52,h:48,duck:false,run:0,onGround:true,invuln:0,atk:0};
    obstacles=[]; enemies=[]; particles=[]; speed=4.0; score=0; spawnT=80; frame=0; gravity=0.50; lives=3; bgT=0;
    updateLives();
  }

  function updateLives(){ if(livesEl) livesEl.textContent='♥'.repeat(Math.max(0,lives)); }

  function jump(){
    if(state==='idle'||state==='dead'){ startGame(); return; }
    if(tiger.onGround){ tiger.vy=-13.6; tiger.onGround=false; }
  }
  function attack(){
    if(state==='idle'||state==='dead'){ startGame(); return; }
    if(tiger.atk<=0) tiger.atk=16; // claw animation timer; hit-check happens in loop
  }
  function setDuck(v){ if(state==='running') tiger.duck=v; }

  function startGame(){
    reset(); state='running';
    overlay.classList.add('hidden');
    loop();
  }
  function gameOver(){
    state='dead';
    best=Math.max(best,Math.floor(score));
    bestEl.textContent=String(best).padStart(4,'0');
    goTitle.textContent='GAME OVER';
    goSub.innerHTML='Score '+String(Math.floor(score)).padStart(4,'0')+' · Best '+String(best).padStart(4,'0')+'<br>Press Space / Tap to run again';
    startBtn.textContent='▶ Run Again';
    overlay.classList.remove('hidden');
  }

  function spawn(){
    // alternate between a post (jump over) and a beast (attack). Beasts unlock after a short warmup.
    const beastsAllowed = score>40;
    if(beastsAllowed && Math.random()<0.45){
      enemies.push({x:W+20,y:GROUND,w:34,h:30,hit:false,wob:Math.random()*6.28});
    } else {
      const tall=Math.random()<0.30 && score>90;
      obstacles.push({x:W+20,type:'gate',w:24,h:tall?40:28,y:GROUND,hit:false});
    }
  }

  function burst(x,y,color){
    for(let i=0;i<8;i++){
      particles.push({x,y,vx:(Math.random()-0.5)*4,vy:-Math.random()*4-1,life:18,color});
    }
  }

  function drawTiger(t){
    // True sprite-frame run animation (3-frame walk cycle, facing right).
    const onG = t.onGround;
    // pick walk-cycle column from run distance; order 0,1,2,1 for a smooth gait
    const seq = [0,1,2,1];
    const col = onG ? seq[Math.floor(t.run*0.5) % seq.length] : 1; // hold neutral mid-air
    const row = PLAYER.runRow;                 // facing right

    // bob + squash for extra life on top of the frames
    const bob = onG ? Math.abs(Math.sin(t.run*0.5))*3 : 0;
    const drawH = t.h * 1.7;                     // a touch larger for the new tiger sheet
    const drawW = drawH;                        // square 64x64 frames (feet aligned to cell bottom)
    const cx = t.x + t.w/2;
    const feetY = t.y - bob;

    ctx.save();
    if(t.invuln>0) ctx.globalAlpha = (Math.floor(t.invuln/6)%2)?0.35:1;

    // contact shadow
    ctx.fillStyle='rgba(0,0,0,.28)';
    const shW=t.w*0.55*(onG?1:0.7);
    ctx.beginPath(); ctx.ellipse(cx, t.y+3, shW, 5, 0, 0, Math.PI*2); ctx.fill();

    // duck = squash; jump = slight stretch
    let sx=1, sy=1;
    if(t.duck){ sx=1.16; sy=0.66; }
    else if(!onG){ sx=0.94; sy=1.08; }

    ctx.translate(cx, feetY);
    ctx.scale(sx, sy);
    if(PLAYER.ready){
      ctx.imageSmoothingEnabled=false;          // crisp pixel art
      ctx.drawImage(
        PLAYER.img,
        col*PLAYER.fw, row*PLAYER.fh, PLAYER.fw, PLAYER.fh,  // source frame
        -drawW/2, -drawH, drawW, drawH                       // dest, anchored at feet
      );
    } else {
      ctx.fillStyle='#ffce4d';
      ctx.fillRect(-drawW/2, -drawH, drawW, drawH);
    }
    // claw slash in front of the tiger while attacking (pixel arcs)
    if(t.atk>0){
      const prog=1-(t.atk/16);                  // 0..1 across the swing
      ctx.imageSmoothingEnabled=false;
      ctx.globalAlpha=0.9*(1-prog);
      const ax=drawW*0.30, ay=-drawH*0.55;
      ctx.fillStyle='#fff2c2';
      for(let k=0;k<3;k++){
        const off=k*7, sweep=prog*16;
        ctx.fillRect(ax+off+sweep, ay+off*1.4-6, 4, 18-off);
      }
      ctx.globalAlpha=1;
    }
    ctx.restore();
  }

  // small pixel beast, palette tuned to read as an enemy beside the tiger
  function drawEnemy(e){
    const px=4;                                  // pixel block size
    const ox=Math.round(e.x), oy=Math.round(e.y);
    const bob=Math.sin(frame*0.2+e.wob)*2;
    ctx.save();
    ctx.imageSmoothingEnabled=false;
    // contact shadow
    ctx.fillStyle='rgba(0,0,0,.28)';
    ctx.beginPath(); ctx.ellipse(ox+e.w/2, GROUND+3, e.w*0.5, 4, 0,0,Math.PI*2); ctx.fill();
    // body grid (1=body,2=dark,3=eye,4=spike)
    const G=[
      "..44..44..",
      ".4224224..",
      "42222222..",
      "12222221..",
      "12322321..",
      "12222221..",
      "11222211..",
      ".1.11.1..."
    ];
    const body='#5a3a6e', dark='#3a2348', eye='#ff4d4d', spike='#c79bff';
    const bx=ox, by=oy-G.length*px - bob;
    for(let r=0;r<G.length;r++){
      for(let c=0;c<G[r].length;c++){
        const ch=G[r][c]; if(ch==='.') continue;
        ctx.fillStyle = ch==='1'?body : ch==='2'?dark : ch==='3'?eye : spike;
        ctx.fillRect(bx+c*px, by+r*px, px, px);
      }
    }
    ctx.restore();
  }

  function drawParticles(){
    particles.forEach(p=>{
      ctx.globalAlpha=Math.max(0,p.life/18);
      ctx.fillStyle=p.color;
      ctx.fillRect(p.x, p.y, 3, 3);
    });
    ctx.globalAlpha=1;
  }

  function drawObstacle(o){
    ctx.save();
    // simple rounded gold post to hop over
    const g=ctx.createLinearGradient(o.x,o.y-o.h,o.x,o.y);
    g.addColorStop(0,'#cdccc6'); g.addColorStop(1,'#6f6f69');
    ctx.fillStyle=g;
    roundRect(o.x,o.y-o.h,o.w,o.h,6); ctx.fill();
    ctx.fillStyle='#ffc233';
    roundRect(o.x,o.y-o.h,o.w,5,3); ctx.fill();
    ctx.restore();
  }

  function roundRect(x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+h,r);ctx.arcTo(x+w,y+h,x,y+h,r);ctx.arcTo(x,y+h,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath();}

  let groundX=0, hillX=0;
  function lerpHex(a,b,t){
    const pa=[parseInt(a.slice(1,3),16),parseInt(a.slice(3,5),16),parseInt(a.slice(5,7),16)];
    const pb=[parseInt(b.slice(1,3),16),parseInt(b.slice(3,5),16),parseInt(b.slice(5,7),16)];
    const r=Math.round(pa[0]+(pb[0]-pa[0])*t), g=Math.round(pa[1]+(pb[1]-pa[1])*t), bl=Math.round(pa[2]+(pb[2]-pa[2])*t);
    return 'rgb('+r+','+g+','+bl+')';
  }
  function drawBackground(){
    // pick current + next theme and blend across the period for a smooth transition
    const idx=Math.floor(bgT/BG_PERIOD)%BGS.length;
    const nxt=(idx+1)%BGS.length;
    const t=(bgT%BG_PERIOD)/BG_PERIOD;
    const a=BGS[idx], b=BGS[nxt];
    // sky
    const top=lerpHex(a.top,b.top,t), bot=lerpHex(a.bot,b.bot,t);
    const sky=ctx.createLinearGradient(0,0,0,GROUND);
    sky.addColorStop(0,top); sky.addColorStop(1,bot);
    ctx.fillStyle=sky; ctx.fillRect(0,0,W,GROUND);
    // stars fade in for night-ish themes (pixel dots)
    const starAmt=a.star*(1-t)+b.star*t;
    if(starAmt>0.02){
      ctx.globalAlpha=starAmt;
      ctx.fillStyle='#fff';
      for(let i=0;i<30;i++){
        const sx=((i*97+frame*0.2)% (W+20))-10;
        const sy=(i*53)%(GROUND-40)+6;
        ctx.fillRect(Math.round(sx),sy,2,2);
      }
      ctx.globalAlpha=1;
    }
    // far hill silhouette band (parallax, pixel-blocky)
    const hill=lerpHex(a.hill,b.hill,t);
    ctx.fillStyle=hill;
    hillX=(hillX-speed*0.3)%80;
    const hy=GROUND-34;
    for(let x=hillX-80;x<W;x+=80){
      ctx.fillRect(x,hy+10,80,30);
      ctx.fillRect(x+18,hy,44,12);   // little bump
    }
  }
  function drawGround(){
    ctx.strokeStyle='rgba(255,194,51,.5)'; ctx.lineWidth=2;
    ctx.beginPath(); ctx.moveTo(0,GROUND); ctx.lineTo(W,GROUND); ctx.stroke();
    ctx.fillStyle='rgba(255,194,51,.25)';
    groundX=(groundX-speed)%40;
    for(let x=groundX;x<W;x+=40){ ctx.fillRect(x,GROUND+8,14,2); }
  }

  function loop(){
    if(state!=='running') return;
    frame++;
    score+=0.10;
    bgT+=0.10;                                    // background drifts at the same rate as score
    speed=Math.min(4.0+score*0.0022, 7.0);   // a bit quicker start, gentle ramp, higher cap
    scoreEl.textContent=String(Math.floor(score)).padStart(4,'0');

    // physics
    tiger.vy+=gravity; tiger.y+=tiger.vy;
    if(tiger.y>=GROUND){ tiger.y=GROUND; tiger.vy=0; tiger.onGround=true; }
    if(tiger.onGround) tiger.run+=speed*0.12;
    if(tiger.atk>0) tiger.atk--;

    // spawn — generous gaps that only tighten a little
    spawnT-=1;
    if(spawnT<=0){ spawn(); spawnT=Math.max(95-score*0.05, 60)+Math.random()*45; }

    if(tiger.invuln>0) tiger.invuln--;
    const tb={x:tiger.x+12,y:tiger.y-40,w:tiger.w-22,h:34};
    // claw reach in front of the tiger while the swing is active
    const clawActive = tiger.atk>0;
    const claw={x:tiger.x+tiger.w-6, y:tiger.y-46, w:46, h:42};

    // POSTS — must be jumped (touching them hurts)
    for(let i=obstacles.length-1;i>=0;i--){
      const o=obstacles[i]; o.x-=speed;
      const ob={x:o.x+3,y:o.y-o.h,w:o.w-6,h:o.h};
      if(!o.hit && tiger.invuln<=0 && tb.x<ob.x+ob.w && tb.x+tb.w>ob.x && tb.y<ob.y+ob.h && tb.y+tb.h>ob.y){
        o.hit=true; lives--; updateLives(); tiger.invuln=60; burst(ob.x,ob.y,'#ffc233');
        if(lives<=0){ gameOver(); }
      }
      if(o.x+o.w<0) obstacles.splice(i,1);
    }

    // BEASTS — must be attacked. Clawing one kills it; running into one hurts.
    for(let i=enemies.length-1;i>=0;i--){
      const e=enemies[i]; e.x-=speed;
      const eb={x:e.x+3,y:e.y-e.h,w:e.w-6,h:e.h};
      if(!e.hit && clawActive && claw.x<eb.x+eb.w && claw.x+claw.w>eb.x && claw.y<eb.y+eb.h && claw.y+claw.h>eb.y){
        e.hit=true; score+=5; burst(eb.x+eb.w/2, eb.y, '#c79bff');
      } else if(!e.hit && tiger.invuln<=0 && tb.x<eb.x+eb.w && tb.x+tb.w>eb.x && tb.y<eb.y+eb.h && tb.y+tb.h>eb.y){
        e.hit=true; lives--; updateLives(); tiger.invuln=60; burst(eb.x+eb.w/2, eb.y, '#ff4d4d');
        if(lives<=0){ gameOver(); }
      }
      if(e.hit) e.fade=(e.fade||0)+1;
      if(e.x+e.w<0 || (e.hit && e.fade>6)) enemies.splice(i,1);
    }

    // particles
    for(let i=particles.length-1;i>=0;i--){
      const p=particles[i]; p.x+=p.vx; p.y+=p.vy; p.vy+=0.3; p.life--;
      if(p.life<=0) particles.splice(i,1);
    }

    // render
    ctx.clearRect(0,0,W,H);
    drawBackground();
    drawGround();
    obstacles.forEach(drawObstacle);
    enemies.forEach(e=>{ if(!e.hit) drawEnemy(e); });
    drawParticles();
    drawTiger(tiger);

    requestAnimationFrame(loop);
  }

  // initial idle frame
  reset();
  ctx.clearRect(0,0,W,H); drawBackground(); drawGround(); drawTiger(tiger);

  // controls
  startBtn.addEventListener('click',startGame);
  window.addEventListener('keydown',e=>{
    if(document.activeElement&&['INPUT','TEXTAREA','SELECT'].includes(document.activeElement.tagName)) return;
    if(e.code==='Space'||e.code==='ArrowUp'){
      e.preventDefault(); jump();
    } else if(e.code==='ArrowDown'){ setDuck(true); }
    else if(e.code==='KeyF'||e.code==='KeyX'){ e.preventDefault(); attack(); }
  });
  window.addEventListener('keyup',e=>{ if(e.code==='ArrowDown') setDuck(false); });
  // touch / pointer — tapping the canvas jumps; dedicated buttons for jump & attack
  cv.addEventListener('pointerdown',e=>{ e.preventDefault(); jump(); });
  overlay.addEventListener('pointerdown',e=>{ if(state!=='running'){ e.preventDefault(); startGame(); }});
  const jumpBtn=document.getElementById('tigerJumpBtn');
  const attackBtn=document.getElementById('tigerAttackBtn');
  if(jumpBtn) jumpBtn.addEventListener('pointerdown',e=>{ e.preventDefault(); jump(); });
  if(attackBtn) attackBtn.addEventListener('pointerdown',e=>{ e.preventDefault(); attack(); });
})();

(function(){
  const root=document.querySelector('.gt-slider'); if(!root) return;
  const track=root.querySelector('.gt-track');
  const slides=Array.from(root.querySelectorAll('.gt-slide')); if(!slides.length) return;
  const dotsWrap=root.querySelector('.gt-dots');
  const prev=root.querySelector('.gt-prev'), next=root.querySelector('.gt-next');
  const reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  let i=0, timer=null;
  const delay=parseInt(root.getAttribute('data-autoplay'),10)||0;

  slides.forEach((s,idx)=>{
    const b=document.createElement('button');
    b.setAttribute('role','tab'); b.setAttribute('aria-label','Slide '+(idx+1));
    b.addEventListener('click',()=>{go(idx);reset();});
    dotsWrap.appendChild(b);
  });
  const dots=Array.from(dotsWrap.children);

  function update(){
    track.style.transform='translateX(-'+(i*100)+'%)';
    dots.forEach((d,idx)=>d.setAttribute('aria-selected', idx===i?'true':'false'));
    slides.forEach((s,idx)=>s.setAttribute('aria-hidden', idx===i?'false':'true'));
  }
  function go(n){ i=(n+slides.length)%slides.length; update(); }
  function nextSlide(){ go(i+1); }
  function prevSlide(){ go(i-1); }
  function reset(){ if(!delay||reduce) return; clearInterval(timer); timer=setInterval(nextSlide,delay); }

  next.addEventListener('click',()=>{nextSlide();reset();});
  prev.addEventListener('click',()=>{prevSlide();reset();});
  root.addEventListener('mouseenter',()=>clearInterval(timer));
  root.addEventListener('mouseleave',reset);

  // keyboard when focused within slider
  root.setAttribute('tabindex','0');
  root.addEventListener('keydown',e=>{
    if(e.key==='ArrowRight'){e.preventDefault();nextSlide();reset();}
    else if(e.key==='ArrowLeft'){e.preventDefault();prevSlide();reset();}
  });

  // swipe
  let x0=null;
  root.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;},{passive:true});
  root.addEventListener('touchend',e=>{
    if(x0===null) return;
    const dx=e.changedTouches[0].clientX-x0;
    if(Math.abs(dx)>40){ dx<0?nextSlide():prevSlide(); reset(); }
    x0=null;
  },{passive:true});

  // pause when offscreen
  if('IntersectionObserver' in window){
    new IntersectionObserver(es=>es.forEach(en=>{ en.isIntersecting?reset():clearInterval(timer); }),{threshold:.25}).observe(root);
  }

  update(); reset();
})();

/* ===================== ITCH.IO EMBEDS + FALLBACK ===================== */
(function(){
  const items=document.querySelectorAll('.itch-item');
  if(!items.length) return;

  items.forEach(item=>{
    const iframe=item.querySelector('.itch-embed iframe');
    const card=item.querySelector('.itch-card');
    const src=item.getAttribute('data-itch-src');
    if(!iframe || !src){ if(card) card.hidden=false; return; }

    let settled=false;
    function showCard(){
      if(settled) return; settled=true;
      const embed=item.querySelector('.itch-embed');
      if(embed) embed.style.display='none';
      if(card) card.hidden=false;
    }
    function ok(){
      if(settled) return; settled=true;
      // embed loaded fine — make sure the card stays hidden
      if(card) card.hidden=true;
    }

    iframe.addEventListener('load',ok);
    iframe.addEventListener('error',showCard);

    // kick off the load
    try { iframe.src=src; } catch(e){ showCard(); }

    // safety net: if the frame never reports a successful load
    // (CSP block, network failure, frame-ancestors denial), fall back.
    setTimeout(()=>{
      if(settled) return;
      let blocked=false;
      try {
        // a CSP/X-Frame-Options block leaves the frame without a reachable document
        if(!iframe.contentWindow){ blocked=true; }
      } catch(e){ /* cross-origin access throwing is normal for a *loaded* frame */ }
      blocked ? showCard() : ok();
    },4000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tome-kills-time"] && !Shopify.designMode) return;
  try {
    
(function(){
  const fs=document.getElementById('tomeFs');
  const frame=document.getElementById('tomeGame');
  if(fs && frame){
    fs.addEventListener('click',()=>{
      const el=frame.closest('.tome-frame-wrap')||frame;
      if(document.fullscreenElement){ document.exitFullscreen&&document.exitFullscreen(); }
      else if(el.requestFullscreen){ el.requestFullscreen(); }
      else if(el.webkitRequestFullscreen){ el.webkitRequestFullscreen(); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
